import { isAllowedToReadEvents } from '@ion/api';

import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';

export default function useCanViewEventDebugger() {
  const { eventDebuggerEcmEnabled } = useFeatureEnabled(FEATURE_FLAGS.eventDebuggerEcm);

  return { canViewEventDebugger: eventDebuggerEcmEnabled && isAllowedToReadEvents() };
}
